var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonAppGalleryLogo = function SvgButtonAppGalleryLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.511 8h10.105c4.766 0 6.501 1.802 6.501 6.75v10.49c0 4.949-1.745 6.76-6.501 6.76H15.51C10.745 32 9 30.189 9 25.24V14.75C9 9.802 10.745 8 15.511 8Zm3.076 15.129.28-.646h1.377l.27.646h.642l-1.327-3.134h-.537l-1.327 3.134h.622Zm1.428-1.214h-.928l.462-1.12.466 1.12Zm9.532-1.92h-.613v3.134h.613v-3.134Zm-1.336 2.566h-1.682v-.774h1.116v-.577h-1.116v-.637h1.616v-.578h-2.22v3.134h2.286v-.568Zm-2.78-2.566h-.64l-.667 2.161-.689-2.16h-.503l-.679 2.16-.67-2.16h-.66l1.06 3.143h.503l.688-2.063.689 2.063h.519l1.05-3.144Zm-7.78 0h-.614v1.799c0 .509-.242.79-.688.79-.447 0-.689-.281-.689-.81V20h-.613v1.792c0 .884.475 1.397 1.293 1.397.836 0 1.31-.52 1.31-1.417v-1.776Zm-3.456 0h-.613v1.264H12.2v-1.264h-.613v3.144h.613v-1.283h1.383v1.283h.613v-3.144Zm2.525-7.983c0 2.2 1.716 3.992 3.845 3.992 2.119 0 3.845-1.796 3.845-3.992h-.538c0 1.89-1.487 3.424-3.307 3.424-1.82 0-3.308-1.534-3.308-3.424h-.537Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 5.5,
    stroke: "currentColor"
  })));
};

export default SvgButtonAppGalleryLogo;